var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-cover-not-land-scape",class:{'--no-event': _vm.isLandscape}},[_c('div',{staticClass:"alert-cover-not-land-scape__inside"},[_c('div',{staticClass:"alert-cover-not-land-scape__content"},[_c('v-icon',[_vm._v("screen_lock_portrait")]),_vm._v(" "),_c('p',[_vm._v("画面を縦にしてご利用ください")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357f3ad6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/AlertCoverNotLandScape.vue
// module id = null
// module chunks = 